<script>
    import has  from 'lodash/has';
    import { mapActions } from 'vuex';
    import Cookie from '@/services/cookie';

    export default {
        methods: {
            ...mapActions('me', {
                $_storeAllUserData: 'storeAllUserData',
            }),

            ...mapActions('auth', {
                $_authLogin: 'login',
                $_authRegister: 'register',
            }),

            $_login(data) {
                const loginData = {
                    email: data.email,
                    password: data.password,
                };
                return this.$_authLogin(loginData).then((response) => {
                    this.$_storeUserAfterLogin(response);
                    return response;
                });
            },

            $_register(data) {
                if (!has(data, 'channel_source')) {
                    data.channel_source = 'applyflow';
                }

                return this.$_authRegister(data).then((response) => {
                    this.$_storeUserAfterRegister(response);
                    return response;
                });
            },

            $_storeUserAfterRegister(data) {
                this.$_storeAllUserData(data);
                Cookie.setToken(data.access_token);
                Cookie.deleteOauthInfo();
            },

            $_storeUserAfterLogin(data) {
                this.$_storeAllUserData(data);
                Cookie.setToken(data.access_token);
                Cookie.deleteOauthInfo();
            },

        },
    };
</script>
